export default ["M12 16v4H8v-4h4zm1-16l-1 14H8L7 0h6z"];